export enum SignInState {
  SIGN_IN,
  SIGN_IN_SENT,
  RE_ENTER_SIGN_IN,
}
